/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Представление попапа заказа товаров с удаленного склада меньше минимума со страницы корзины
   */
  app.CartRemotePopupView = app.ItemsPopupView.extend({
    events: {
      'click .js-to-checkout': 'goToCheckout',
      'mousedown .js-partner-order-limit-news-link': 'onGoToPartnerOrderLimitNews'
    },
    el: '.js-checkout-remote-popup',

    // необходимый маркер для отправки событий в ОКО
    popupType: 'checkout_popup',

    run: function () {
      this.headTemplate = app.helpers.TemplateHelper.getTemplate('#head-content-template');
      this.buttonTemplate = app.helpers.TemplateHelper.getTemplate('#remote-content-template');
      this.itemsTemplate = app.helpers.TemplateHelper.getTemplate('#popup-items-template');
      this.initPopup();
      this.listenTo(this.settlement, 'update', this.updateSum);
      this.listenTo(this.cart, 'update', this.updateSum);
      this.listenTo(this.cart, 'currency-set', this.updateSum);
      this.updateSum();
    },

    /**
     * Действия перед закрытием попапа
     */
    beforePopupClose: function () {
      this.openMinSumPopup();
    },

    render: function () {
      var remoteGroup = _.find(this.collection.cartInfo.groups, {code: 'remote'}),
        remoteSum = remoteGroup.sum,
        templateData = {
          items: this.collection.toJSON(),
          cartSum: remoteSum,
          currencySign: app.currentCurrency.sign,
          fractionNumber: app.helpers.NumberHelper.fractionNumber
        };

      var markup = this.itemsTemplate(templateData) + this.buttonTemplate(templateData);

      this.$('.js-remote-content-container').html(markup);
      this.open();
    },

    /**
     * Отправляем на оформление заказа товаров с удаленного склада меньше минимума
     */
    goToCheckout: function () {
      this.beforeButtonAction();

      // отправляем в ОКО необходимые данные о заказе
      app.helpers.OkoHelper.push({
        'n': 'custom',
        'category': 'remote_order_popup',
        'custom_str': [this.popupType, 'goto_order']
      });

      app.helpers.RedirectHelper.goToCheckout({is_remote: true});
    },

    /**
     * Переходим на страницу новости об отмене минимальной суммы заказа для товаров партнёров
     */
    onGoToPartnerOrderLimitNews: function () {
      // Отправляем в ОКО данные об переходе на страницу новости
      app.helpers.OkoHelper.push({
        'n': 'custom',
        'category': 'remote_order_popup',
        'custom_str': [this.popupType, 'goto_news']
      });
    },

    /**
     * Открываем попап
     */
    open: function () {
      app.ItemsPopupView.prototype.open.call(this);
      this.okoPushOpen();
    },

    /**
     * Сообщаем ОКО об открытии попапа
     */
    okoPushOpen: function () {
      app.helpers.OkoHelper.push({
        'n': 'custom',
        'category': 'remote_order_popup',
        'custom_str': [this.popupType, 'popup_view']
      });
    },

    /**
     * Отправляем событие об открытии попапа с минимальной суммой
     */
    openMinSumPopup: function () {
      this.trigger('show-min-sum-message');
    },

    /**
     * Обновление информации о минимальной сумме в выбранном городе.
     */
    updateSum: function () {
      var minSumOrder = app.helpers.NumberHelper.fractionNumber(this.cart.minOrderSum)[0];
      var cityName = this.settlement.get('name');
      this.$('.js-popup-minsum_sum').html(this.headTemplate({
        minSumOrder: minSumOrder,
        cityName: cityName,
        currentCurrency: this.cart.currency,
      }));
    }
  });
})(jQuery);

}.call(window));